
import { IInsurancePreQuestionnaireState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {  onNgrxForms, onNgrxFormsAction, SetValueAction, createFormGroupState, updateGroup, validate, wrapReducerWithFormStateUpdate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { ShowPreQuestionnaireResponseAction,  ShowStartQuestionnaireRequestAction, ResetPreQuestionnaireRequestAction, PreQuestionnaireWordingResponseAction } from './actions';
import { InsurancePreQuestionnaireRequestModel } from 'src/app/model/insurance-questionnaire.model';

export const formName = 'insurancePreQuestionnaireRequestForm';

export const validatePreInsuranceQuestionnaireRequestForm = updateGroup<InsurancePreQuestionnaireRequestModel>({
  hasPreExistingConditionOrDisability :validate(required),
  isPlanningToTakeLeaveWithoutPay:validate(required),
  engageInHazardousPursuits : validate(required)
});

export const state: IInsurancePreQuestionnaireState = {
  form: createFormGroupState(formName, new InsurancePreQuestionnaireRequestModel()),
  showQuestionnaire: false,
  showPreQuestionnaire:true,
  showStartQuestionnaire:false,
  wording:null
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResetPreQuestionnaireRequestAction, (state) => {
    return {
      ...state,
      showPreQuestionnaire : true,
      showStartQuestionnaire: false
    };
  }),
    on(ShowStartQuestionnaireRequestAction, (state, { display }) => {
      if(!display)
      return;

        return {
        ...state,
        showPreQuestionnaire : !display,
        showStartQuestionnaire: display
      };
  }),
  on(ShowPreQuestionnaireResponseAction, (state, { payload }) => {
    return {
      ...state,
      form: createFormGroupState(formName, new InsurancePreQuestionnaireRequestModel()),
      showQuestionnaire: payload.show,
      showPreQuestionnaire : true,
      showStartQuestionnaire: false
    };
  }),
  on(PreQuestionnaireWordingResponseAction, (state, {wording} ) => {
    return {
      ...state,
      wording
    }
  })
);

export function insurancePreQuestionnaireReducer(state: any | undefined, action: Action) {
  return editInsuranceRequestReducerFormState(state, action);
}

const editInsuranceRequestReducerFormState = wrapReducerWithFormStateUpdate(
  reducer,
  s => s.form,
  validatePreInsuranceQuestionnaireRequestForm,
);

